import { CommonActions } from '@react-navigation/native';
import { router, useRootNavigationState } from 'expo-router';
import { Linking } from 'react-native';

// This method will recreate the existing route stack, but removing the last entry of the provided routeName.
// It's a hack to be used in situations where we want to force the page mount again but keeping the existing routes on our stack.
export const removeRouteFromStack = async (navigation, routeName): Promise<void> => {
  const routes = navigation.getState().routes;
  const lastIndex = routes.map(route => route.name).lastIndexOf(routeName);

  if (lastIndex === -1) {
    return Promise.resolve();
  }

  const filteredRoutes = routes.filter((_, index) => index !== lastIndex);

  await navigation.dispatch(
    CommonActions.reset({
      index: filteredRoutes.length - 1,
      routes: filteredRoutes,
    })
  );
};

export function useIsNavigationReady() {
  const rootNavigationState = useRootNavigationState();
  const isRootNavigationReady = (rootNavigationState?.routes?.[0]?.state?.routes?.length ?? 0) > 0;

  return isRootNavigationReady;
}

const associatedDomains = [
  'firehousesubs.test-app.link',
  'firehousesubs-alternate.test-app.link',
  'firehousesubs.app.link',
  'firehousesubs-alternate.app.link',
  'www.firehousesubs.com',
  'firehousesubs.com',
  'dev-fhs-rn-web.com.rbi.tools',
  'qa-fhs-rn-web.com.rbi.tools',
  'prod-fhs-rn-web.com.rbi.tools',
  'firehousesubsca.test-app.link',
  'firehousesubsca-alternate.test-app.link',
  'firehousesubsca.app.link',
  'firehousesubsca-alternate.app.link',
  'www.firehousesubs.ca',
  'firehousesubs.ca',
  'dev-fhs-rn-web.ca.rbi.tools',
  'qa-fhs-rn-web.ca.rbi.tools',
  'prod-fhs-rn-web.ca.rbi.tools',
];

const isDeepLink = (url: string) => {
  return associatedDomains.some(domain => url.includes(domain));
};

const extractRouteFromDeepLink = (url: string): string => {
  try {
    const urlObj = new URL(url);
    return urlObj.pathname;
  } catch {
    // If URL parsing fails
    const domainMatch = associatedDomains.find(domain => url.includes(domain));
    if (domainMatch) {
      const domainIndex = url.indexOf(domainMatch);
      const pathStart = domainIndex + domainMatch.length;
      return url.substring(pathStart) || '/';
    }
    return url;
  }
};

export const handleDeepLink = (url: string) => {
  if (isDeepLink(url)) {
    const route = extractRouteFromDeepLink(url);

    router.navigate(route);
    return;
  }

  Linking.openURL(url);
};
